/** @format */

import { AvailabilityObject } from './availability-object.interface';

export interface NestDefiningAttribute {
  availabilityMap: AvailabilityObject[];
  identifier?: string;
  name: string;
  selected?: boolean;
  seq?: number | string;
  swatchImage?: string;
  swatches?: string;
  value?: string;
  values?: string;
}
